// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"ButtonLoader_loader_wrapper__3McQ8","loader":"ButtonLoader_loader__AH7Qd","rotation":"ButtonLoader_rotation__VZDZd"};